import React from 'react'
import { RouteProps } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { selectors } from '../../../redux'
import AuthenticationPage from '../Authentication'

import UpdateSlotPage from './UpdateSlot'
import ModifySuccessPage from './Success'

const ModifyPage: React.FC<RouteProps> = () => {
  const visitor = useSelector(selectors.app.visitor)
  const updateRegistration = useSelector(selectors.app.updateRegistration)
  const hasUpdatedSlot = updateRegistration?.success ?? false

  if (!visitor) {
    return <AuthenticationPage />
  }

  if (hasUpdatedSlot) {
    return <ModifySuccessPage />
  }

  return <UpdateSlotPage />
}

export default ModifyPage
